import account from './account.json';
import aiReceptionistSettings from './ai-receptionist-settings.json';
import aiReceptionist from './ai-receptionist.json';
import aiOnboarding from './aiOnboarding.json';
import analyticsMarketingAttribution from './analytics-marketing-attribution.json';
import analytics from './analytics.json';
import base from './base.json';
import beta from './beta.json';
import billingAlerts from './billingAlerts.json';
import branding from './branding.json';
import bulkMessaging from './bulk-messaging.json';
import bundle from './bundle.json';
import bundleUpgrade from './bundleUpgrade.json';
import businessInfo from './business-info.json';
import callIntelligence from './call-intelligence.json';
import callLogs from './call-logs.json';
import callIntelDashboardWidgets from './callIntelDashboardWidgets.json';
import callIntelInsights from './callIntelInsights.json';
import calls from './calls.json';
import chat from './chat.json';
import contacts from './contacts.json';
import dataSources from './dataSources.json';
import devices from './devices.json';
import digitalFormsExperience from './digital-forms-experience.json';
import digitalFormsSignupPage from './digitalFormsSignupPage.json';
import entity from './entity.json';
import example from './example.json';
import fax from './fax.json';
import featurePromotion from './featurePromotion.json';
import forms from './forms.json';
import highValueAdoption from './highValueAdoption.json';
import home from './home.json';
import insurance from './insurance.json';
import insuranceDetails from './insuranceDetails.json';
import insuranceVerification from './insuranceVerification.json';
import integrations from './integrations.json';
import locations from './locations.json';
import marketing from './marketing.json';
import messages from './messages.json';
import onboarding from './onboarding.json';
import onboardingDashboard from './onboardingDashboard.json';
import onlineScheduling from './onlineScheduling.json';
import onlineSchedulingSignUpPage from './onlineSchedulingSignUpPage.json';
import organizationBilling from './organizationBilling.json';
import payments from './payments.json';
import phone from './phone.json';
import phoneProviderInformationForm from './phoneProviderInformationForm.json';
import phoneSync from './phoneSync.json';
import pop from './pop.json';
import porting from './porting.json';
import portingLoa from './portingLoa.json';
import productOnboardingTasks from './productOnboardingTasks.json';
import purchaseDevices from './purchaseDevices.json';
import resetPassword from './resetPassword.json';
import reviews from './reviews.json';
import salesDev from './salesDev.json';
import scheduleActivity from './schedule-activity.json';
import scheduleOnboarding from './schedule-onboarding.json';
import schedulePulse from './schedule-pulse.json';
import scheduleQuickFill from './schedule-quick-fill.json';
import scheduleRequestHistory from './schedule-request-history.json';
import scheduleRequest from './schedule-request.json';
import scheduleSettings from './schedule-settings.json';
import schedule from './schedule.json';
import scheduleTraining from './scheduleTraining.json';
import settings from './settings.json';
import setupMobileNumber from './setupMobileNumber.json';
import signIn from './SignIn.json';
import softphone from './softphone.json';
import staffPerformance from './staff-performance.json';
import subscribe from './subscribe.json';
import subscription from './subscription.json';
import syncAppAuth from './syncAppAuth.json';
import teamChat from './team-chat.json';
import textConnectSignupPage from './textConnectSignupPage.json';
import units from './units.json';
import userCreate from './userCreate.json';
import weavePay from './weave-pay.json';

export default {
  account,
  aiReceptionist,
  aiOnboarding,
  analytics,
  analyticsMarketingAttribution,
  aiReceptionistSettings,
  base,
  beta,
  billingAlerts,
  'bulk-messaging': bulkMessaging,
  bundle,
  bundleUpgrade,
  branding,
  businessInfo,
  callIntelligence,
  callIntelDashboardWidgets,
  callIntelInsights,
  calls,
  callLogs,
  chat,
  contacts,
  dataSources,
  digitalFormsSignupPage,
  entity,
  example,
  fax,
  featurePromotion,
  forms,
  highValueAdoption,
  home,
  insurance,
  insuranceVerification,
  locations,
  marketing,
  messages,
  onboarding,
  onboardingDashboard,
  payments,
  phone,
  phoneSync,
  pop,
  purchaseDevices,
  resetPassword,
  reviews,
  salesDev,
  schedule,
  'schedule-onboarding': scheduleOnboarding,
  setupMobileNumber,
  signIn,
  softphone,
  subscribe,
  subscription,
  units,
  weavePay,
  portingLoa,
  devices,
  onlineSchedulingSignUpPage,
  onlineScheduling,
  productOnboardingTasks,
  porting,
  integrations,
  phoneProviderInformationForm,
  insuranceDetails,
  organizationBilling,
  syncAppAuth,
  textConnectSignupPage,
  userCreate,
  'schedule-activity': scheduleActivity,
  'schedule-quick-fill': scheduleQuickFill,
  'schedule-pulse': schedulePulse,
  'schedule-request': scheduleRequest,
  'schedule-request-history': scheduleRequestHistory,
  'schedule-settings': scheduleSettings,
  'team-chat': teamChat,
  scheduleTraining,
  settings,
  'digital-forms-experience': digitalFormsExperience,
  staffPerformance,
};
